import { userLockConstants } from '../constants/userlock.constants';

export function userlock(state = {}, action) {
  switch (action.type) {
    case userLockConstants.FETCH_REQUEST:
      return {
        ...state,
        loading: true
      };    
    case userLockConstants.FETCH_SUCCESS:      
      return {
        ...state,
        ...action.notifications,
        loading: false
      };
    case userLockConstants.FETCH_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };   
    default:
      return state
  }
}
